import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Rightpart.css";
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { fetchAPI, fetchUserAppAPI } from "../../utils/api";
import { ShimmerTable } from "react-shimmer-effects";

export default function DashboardRight() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [productOrders, setProductOrders] = useState([]);
  const [serviceOrders, setServiceOrders] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [loadingServices, setLoadingServices] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) {
      navigate("/login");
      return;
    }
    const parsedUser = JSON.parse(storedUser);
    setUser(parsedUser);

    const fetchProductOrders = async () => {
      try {
        setLoadingProducts(true);
        const res = await fetchUserAppAPI("equipments-list-order", {
          method: "POST",
          body: JSON.stringify({ user_id: parsedUser.user_id }),
        });
        if (res && res.status === 200 && Array.isArray(res.result)) {
          setProductOrders(res.result);
        }
      } catch (err) {
        console.error("Error fetching product orders in dashboard:", err);
      } finally {
        setLoadingProducts(false);
      }
    };

    const fetchServiceOrders = async () => {
      try {
        setLoadingServices(true);
        let res = null;
        try {
          res = await fetchAPI("CaregiverController/order_list", {
            method: "POST",
            body: JSON.stringify({ user_id: parsedUser.user_id }),
          });
        } catch (e) {
          res = await fetchUserAppAPI("services-order-list", {
            method: "POST",
            body: JSON.stringify({ user_id: parsedUser.user_id }),
          });
        }
        if (res && res.status === 200 && Array.isArray(res.result)) {
          setServiceOrders(res.result);
        }
      } catch (err) {
        console.error("Error fetching service orders in dashboard:", err);
      } finally {
        setLoadingServices(false);
      }
    };

    fetchProductOrders();
    fetchServiceOrders();
  }, [navigate]);

  const totalBookings = productOrders.length + serviceOrders.length;
  const productSpent = productOrders.reduce((sum, o) => sum + (parseFloat(o.order_grand_total) || 0), 0);
  const serviceSpent = serviceOrders.reduce((sum, o) => sum + (parseFloat(o.total_amount || o.ord_total_amount) || 0), 0);
  const totalSpent = productSpent + serviceSpent;

  const activeProductOrders = productOrders.filter(o => !o.order_status || o.order_status.toLowerCase() === 'pending' || o.order_status.toLowerCase() === 'active' || o.order_status.toLowerCase() === 'processing').length;
  const activeServiceOrders = serviceOrders.filter(o => !o.order_status || o.order_status.toLowerCase() === 'pending' || o.order_status.toLowerCase() === 'active' || o.order_status.toLowerCase() === 'processing').length;
  const activeBookings = activeProductOrders + activeServiceOrders;

  const totalItemsCount = productOrders.reduce((sum, o) => sum + (o.items ? o.items.length : 0), 0) + serviceOrders.length;

  return (
    <div className="outer-div-right">
      <div className="dashbord-right-section">
        <div className="content-dashborad-outer">
          
          <div className="mb-4">
            <h3 className="text-dark fw-bold">Welcome back, {user ? `${user.user_first_name} ${user.user_last_name}` : "User"}!</h3>
            <p className="text-muted small">Here is your care at home dashboard overview.</p>
          </div>

          <div className="iner-boxes-dr">
            <div className="main-box-dr">
              <p>Total Orders</p>
              <div className="number-iconn">
                <h4>{totalBookings}</h4>
                <div className="box-img-1 box-img">
                  <AssignmentOutlinedIcon/>
                </div>
              </div>
            </div>
            <div className="main-box-dr">
              <p>Total Spent</p>
              <div className="number-iconn">
                <h4>₹{totalSpent.toLocaleString('en-IN')}</h4>
                <div className="box-img-2 box-img">
                  <ScheduleOutlinedIcon/>
                </div>
              </div>
            </div>
            <div className="main-box-dr">
              <p>Ordered Products</p>
              <div className="number-iconn">
                <h4>{totalItemsCount}</h4>
                <div className="box-img-3 box-img">
                  <MedicalServicesOutlinedIcon />
                </div>
              </div>
            </div>
            <div className="main-box-dr">
              <p>Active Orders</p>
              <div className="number-iconn">
                <h4>{activeBookings}</h4>
                <div className="box-img-4 box-img">
                  <AccessTimeFilledIcon/>
                </div>
              </div>
            </div>
          </div>

          {/* Product On Rent Table */}
          <div className="table-dashbord table-responsive mb-4">
            <div className="d-flex justify-content-between align-items-center" style={{ padding: "20px" }}>
              <h5 className="mb-0 fw-bold">Product On Rent</h5>
              <Link to="/myorders" style={{ color: '#13baac', textDecoration: 'none', fontWeight: '600' }}>
                View All Orders &rarr;
              </Link>
            </div>

            {loadingProducts ? (
              <div className="p-3">
                <ShimmerTable row={3} col={6} />
              </div>
            ) : productOrders.length === 0 ? (
              <div className="text-center py-4 text-muted">
                <p className="mb-2">No product rent orders found.</p>
                <Link to="/product-on-rent" className="btn btn-sm" style={{ backgroundColor: '#13baac', color: '#fff' }}>
                  Explore Products On Rent
                </Link>
              </div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Order No</th>
                    <th>Product</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Payment</th>
                    <th>Status</th> 
                  </tr>
                </thead>

                <tbody>
                  {productOrders.slice(0, 5).map((order) => {
                    const firstItem = order.items && order.items.length > 0 ? order.items[0] : null;
                    const itemName = firstItem ? firstItem.product_name : "Medical Equipment";
                    const extraItems = order.items && order.items.length > 1 ? ` (+${order.items.length - 1} more)` : "";
                    const createdDate = order.order_created 
                      ? new Date(order.order_created).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
                      : '-';

                    return (
                      <tr key={order.order_id}>
                        <td>
                          <Link to={`/myorders?id=${order.order_no}`} style={{ color: '#13baac', textDecoration: 'none', fontWeight: 'bold' }}>
                            {order.order_no}
                          </Link>
                        </td>
                        <td>{itemName}{extraItems}</td>
                        <td>{createdDate}</td>
                        <td>₹{parseFloat(order.order_grand_total || 0).toLocaleString('en-IN')}</td>
                        <td>{order.order_payment_method || 'COD'}</td>
                        <td>
                          <span className={`status ${(order.order_status || 'Pending').toLowerCase()}`}>
                            {order.order_status || 'Pending'}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>

          {/* Healthcare Services Bookings Table */}
          <div className="table-dashbord table-responsive">
            <div className="d-flex justify-content-between align-items-center" style={{ padding: "20px" }}>
              <h5 className="mb-0 fw-bold">Healthcare Services Bookings</h5>
              <Link to="/myorderDetail" style={{ color: '#13baac', textDecoration: 'none', fontWeight: '600' }}>
                View All Bookings &rarr;
              </Link>
            </div>

            {loadingServices ? (
              <div className="p-3">
                <ShimmerTable row={3} col={6} />
              </div>
            ) : serviceOrders.length === 0 ? (
              <div className="text-center py-4 text-muted">
                <p className="mb-2">No service bookings found.</p>
                <Link to="/caregiver" className="btn btn-sm" style={{ backgroundColor: '#13baac', color: '#fff' }}>
                  Explore Caregiver & Nursing Services
                </Link>
              </div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Booking No</th>
                    <th>Service</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Payment</th>
                    <th>Status</th> 
                  </tr>
                </thead>

                <tbody>
                  {serviceOrders.slice(0, 5).map((order, idx) => {
                    const firstItem = order.items && order.items.length > 0 ? order.items[0] : null;
                    const serviceName = firstItem 
                      ? (firstItem.service?.title || firstItem.package?.title || firstItem.ord_service_title || "Healthcare Service")
                      : (order.ord_service_title || "Healthcare Service");
                    const extraItems = order.items && order.items.length > 1 ? ` (+${order.items.length - 1} more)` : "";
                    const rawDate = order.created || order.ord_created || order.created_at;
                    const createdDate = rawDate 
                      ? new Date(rawDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
                      : '-';
                    const bookingNo = order.order_number || order.ord_number || `SRV-${order.order_id || idx + 1}`;
                    const amount = order.total_amount || order.ord_total_amount || 0;
                    const status = order.order_status || order.ord_status || 'Pending';
                    const paymentStatus = order.payment_status || order.ord_payment_status || 'Cash on Delivery';

                    return (
                      <tr key={order.order_id || idx}>
                        <td>
                          <Link to="/myorderDetail" style={{ color: '#13baac', textDecoration: 'none', fontWeight: 'bold' }}>
                            {bookingNo}
                          </Link>
                        </td>
                        <td>{serviceName}{extraItems}</td>
                        <td>{createdDate}</td>
                        <td>₹{parseFloat(amount || 0).toLocaleString('en-IN')}</td>
                        <td>{paymentStatus}</td>
                        <td>
                          <span className={`status ${(status || 'Pending').toLowerCase()}`}>
                            {status}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}
